import { DAYS, SLOTS } from "@/lib/studio";

export const Hours = () => (
  <section id="hours" className="grid-lines scroll-mt-20 border-y border-white/10 bg-[#0d0d10]" data-testid="hours-section">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-12">
      <p className="eyebrow">Operating hours</p>
      <h2 className="mt-4 font-display text-3xl font-bold uppercase tracking-tight text-white lg:text-4xl">Weekdays. Three sessions a day.</h2>
      <p className="mt-4 max-w-xl text-sm text-zinc-400">Closed Saturday and Sunday. Each session is a four-hour block of the studio.</p>
      <div className="mt-12 overflow-x-auto">
        <table className="w-full min-w-[640px] border-collapse" data-testid="hours-table">
          <thead>
            <tr>
              <th className="w-48 border-b border-white/10 pb-4 text-left font-tech text-xs uppercase tracking-[0.2em] text-zinc-500">Session</th>
              {DAYS.map((d) => (
                <th key={d} className="border-b border-white/10 pb-4 text-left font-tech text-xs uppercase tracking-[0.2em] text-zinc-500">{d.slice(0, 3)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {SLOTS.map((s) => (
              <tr key={s.id} className="group">
                <td className="border-b border-white/5 py-6">
                  <p className="font-display text-lg font-semibold uppercase text-white">{s.label}</p>
                  <p className="font-tech text-xs text-zinc-500">{s.time}</p>
                </td>
                {DAYS.map((d) => (
                  <td key={d} className="border-b border-white/5 py-6">
                    <span className="inline-block h-2 w-10 rounded-full bg-[#FF3333]/70 transition-colors group-hover:bg-[#FF3333]" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);
